<template>
  <v-container fluid grid-list-sm>

    <v-layout row class="d-flex justify-center">
      <v-flex md12>
        <v-alert
          v-model="reporteEnviado"
          color="light-green darken-1"
          icon="check_circle"
          dismissible
        >
          Su reporte a sido enviado
        </v-alert>
        <v-alert
          v-model="error"
          color="error"
          icon="check_circle"
          dismissible
        >
          Ocurrió un problema al enviar su reporte, intentelo más tarde.
        </v-alert>
      </v-flex>
    </v-layout>

    <v-layout row class="d-flex justify-center">
      <v-flex md12>
        <v-card>
          <v-card-text>
            Es necesario capturar los datos de tu servicio social.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row class="d-flex justify-center" v-if="solicitud.capturado">
      <v-flex md6>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Servicio Social - Reportes</h3>
            </div>
          </v-card-title>
          <v-card-text style="min-height: 200px">
            <v-layout row wrap>
              <v-flex xs12 sm12>
                <v-select
                  :items="selectItems"
                  v-model="reporte.no_reporte"
                  label="Número de reporte"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-dialog
                  ref="fromDialog"
                  v-model="fromDateModal"
                  :return-value.sync="reporte.fromDate"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="reporte.fromDate"
                      label="Desde día"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="reporte.fromDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="fromDateModal = false">Cancelar</v-btn>
                    <v-btn flat color="primary" @click="$refs.fromDialog.save(reporte.fromDate)">Aceptar</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12 md6>
                <v-dialog
                  ref="untilDialog"
                  v-model="untilDateModal"
                  :return-value.sync="reporte.untilDate"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="reporte.untilDate"
                      label="Desde día"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="reporte.untilDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="untilDateModal = false">Cancelar</v-btn>
                    <v-btn flat color="primary" @click="$refs.untilDialog.save(reporte.untilDate)">Aceptar</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Total de Horas"
                  v-model="reporte.horas"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Horas acumuladas"
                  v-model="reporte.horas_acumuladas"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  label="Resumen de actividades realizadas"
                  v-model="reporte.resumen"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="sendingReport" @click="save">Enviar reporte</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex md6>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Descargas</h3>
            </div>
          </v-card-title>
          <v-card-text style="min-height: 200px" v-if="cargandoDatos">
            <v-progress-linear
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-card-text>

          <v-list two-line v-else>
            <template v-for="item in items">
              <v-list-tile
                :key="item.id"
                href="#"
                @click="downloadFile(item)"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.titulo"></v-list-tile-title>
<!--                      <v-list-tile-sub-title class="text&#45;&#45;primary">{{ item.docente }}</v-list-tile-sub-title>-->
<!--                      <v-list-tile-sub-title>{{ item.clave }}</v-list-tile-sub-title>-->
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon
                    color="teal"
                  >
                    cloud_download
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import fileSaver from 'file-saver'

  export default {
    name: 'ServicioSocialDescargas',
    data: () => ({
      cargandoDatos: false,
      items: [],
      documentExist: false,
      generandoPdf: false,
      selectItems: [
        {value: 1, text: 'Primer reporte'},
        {value: 2, text: 'Segundo reporte'},
        {value: 3, text: 'Tercer reporte'}
      ],
      fromDateModal: false,
      untilDateModal: false,
      reporte: {
        no_reporte: 0,
        horas: undefined,
        horas_acumuladas: undefined,
        fromDate: new Date().toISOString().substr(0, 10),
        untilDate: new Date().toISOString().substr(0, 10),
        resumen: ''
      },
      reporteDefault: {
        no_reporte: 0,
        horas: undefined,
        horas_acumuladas: undefined,
        fromDate: new Date().toISOString().substr(0, 10),
        untilDate: new Date().toISOString().substr(0, 10),
        resumen: ''
      },
      sendingReport: false,
      reporteEnviado: false,
      error: false,
      solicitud: {}
    }),
    computed: {
      ...mapState({
        alumno: state => state.user.profile
      })
    },
    methods: {
      checkDocumentExist () {
        this.cargandoDatos = true
        axios.get(this.document, { headers: { 'Authorization': '', 'Accept': 'application/pdf' }, responseType: 'arraybuffer' })
          .then(() => {
            this.documentExist = true
          })
          .catch(error => {
            console.log(error.data)
          })
          .finally(() => {
            this.cargandoDatos = false
          })
      },
      getDocumentos () {
        this.cargandoDatos = true
        axios.get('alumno/servicio-social/reportes/listar-descargas')
          .then(response => {
            this.cargandoDatos = false
            this.items = response.data.data
            console.log(response.data)
          })
      },
      downloadFile (item) {
        this.generandoPdf = true
        axios.get(item.url, { headers: { 'Accept': 'application/pdf' }, responseType: 'arraybuffer' })
          .then(response => {
            this.generandoPdf = false
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, item.titulo + '.pdf')
          })
          .catch(error => {
            console.log(error.data)
          })
          .finally(() => {
            this.cargandoDatos = false
          })
      },
      resetForm () {
        this.reporte = Object.assign({}, this.reporteDefault)
      },
      save () {
        this.sendingReport = true
        axios.post('alumno/servicio-social/reportes/create', this.reporte)
          .then(response => {
            this.sendingReport = false
            console.log(response.data)
            this.resetForm()
            this.reporteEnviado = true
          })
          .catch(error => {
            console.error(error)
            this.error = true
          })
      },
      cargarDatos () {
        console.log('CARGAR - SERVICIO SOCIAL')
        this.cargandoDatos = true
        axios.get('alumno/solicitud-servicio-social')
          .then(response => {
            this.cargandoDatos = false
            this.solicitud = response.data
            this.solicitud.capturado = JSON.parse(response.data.capturado)
            this.departamentos = [
              {clave: 'Ninguno', descripcion: 'Ninguno'},
              ...response.data.departamentos
            ]
            console.log('departamentos', this.departamentos)
            delete this.solicitud.departamentos
          })
      }
    },
    mounted () {
      this.getDocumentos()
      this.cargarDatos()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/information/ServicioSocialReportesPage.vue